import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
{
  path: '/',
  redirect: '/month/hot/1057'
},
{
  path: '/week/:id',
  name: 'Week',
  component: () => import('../views/Week'),
  meta: {
    title: 'VIP精选内容周榜',
    keepAlive: true
  }
}, {
  path: '/month/:id',
  name: 'Month',
  component: () => import('../views/Month'),
  meta: {
    title: '6月最高人气内容榜单',
    keepAlive: true
  },
},{
  path: '/month/hot/:id',
  name: 'MonthHot',
  component: () => import('../views/MonthHot'),
  meta: {
    title: '7月VIP最高人气榜单',
    keepAlive: true
  },
}]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

router.afterEach((to, from) => {})

export default router